// @flow
import { path } from "ramda"
import type { DateRange, DateString } from "data/units/date/types"

export const setActiveDates = (originalReservation: DateRange) => {
  if (originalReservation)
    return {
      startDate: originalReservation.startDate,
      endDate: undefined,
    }
  return undefined
}

export const resetDates = (props: any, v?: DateString) => {
  // Clear any error messages
  props.clearError()

  // v or check if extending a reservation
  const startDate = v || path(["originalReservation", "startDate"], props)

  // Creating reservation and we have start date value
  return props.setValue({
    startDate,
    endDate: undefined,
  })
}



// WEBPACK FOOTER //
// ./src/modals/ProductAvailability/helpers.js